import React from 'react';

const NotFound = () => {
    return (
        <div className="text-center">
            <h1>404 error</h1>
            <p>URL Not Found</p>
        </div>
    );
};

export default NotFound;